<!-- ── ngbDropdown wrapper — mirrors the multiple-suggester pattern ──────────── -->
<div
  ngbDropdown
  #dropdown="ngbDropdown"
  class="multiple-suggester location-suggester"
  placement="bottom top"
  [autoClose]="modal ? false : 'outside'"
  (openChange)="onOpenChange($event)"
  [ngClass]="{ 'multiple-suggester-with-items': chipItems().length }"
>
  <!-- ── Anchor: chip group + search input ────────────────────────────────── -->
  <div
    #anchor
    ngbDropdownAnchor
    class="input-group-right-icon form-control position-relative"
    [class.input-focus]="isFocused()"
    (click)="focusInput()"
  >
    <!-- Chips — delegated to f-location-chip-group which owns the popover
         template and the mobile-modal pending-items buffer. -->
    <f-location-chip-group
      class="selected-items"
      [items]="$any(chipItems())"
      [invalidItems]="$any(excludedChipItems())"
      (click)="$event.stopPropagation()"
      (remove)="onChipRemove($any($event))"
      (removeAll)="onRemoveAll()"
      (itemClick)="onChipItemClick($event)"
    ></f-location-chip-group>

    <!-- Input wrapper -->
    <div class="input-wrapper">
      <input
        #inputEl
        type="text"
        data-automation-id="location-suggester-input"
        [placeholder]="resolvedLabels.placeholder"
        [formControl]="inputValue"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (keydown)="onKeyDown($event)"
        (click)="openMobileModal(); $event.stopPropagation()"
        (select)="$event.stopPropagation()"
      />
      @if (searchText().length) {
      <i class="f-i f-i-close" (click)="clearSearch($event)"></i>
      }
    </div>
  </div>

  <!-- ── Dropdown results panel ───────────────────────────────────────────── -->
  <div #resultsBox ngbDropdownMenu [fDropdownWidth]="anchor" [dropdown]="dropdown">
    <f-list class="location-suggester-list" [withConcisedItems]="false">
      <!-- ── Typeahead suggestions (while typing) ─────────────────────────── -->
      @if (showSuggest()) { @for (item of suggestedItems(); track item.key; let i = $index) {
      <f-list-item
        class="suggest-item location-item d-flex align-items-center justify-content-between gap-2 px-3"
        [ngClass]="'location-item-type-' + item.data.type"
        [active]="isItemActive(item)"
        [withHover]="true"
        [class.location-item-highlighted]="i === highlightedSuggestIndex()"
        (click)="toggleSelectionType(item); $event.stopPropagation()"
      >
        <span class="suggest-item-text flex-grow-1 overflow-hidden text-truncate">
          <span class="suggest-item-text-before">{{ item.data.name.substring(0, item.searchContext.startIdx) }}</span>
          <span class="suggest-item-text-match fw-bold">{{
            item.data.name.substring(item.searchContext.startIdx, item.searchContext.endIdx)
          }}</span>
          <span class="suggest-item-text-after text-muted">{{ getSuggestSuffix(item) }}</span>
        </span>

        <div class="d-flex gap-2 flex-shrink-0">
          <a
            class="link-danger location-item-button-exclude"
            [class.fw-bold]="isItemExcluded(item)"
            (click)="selectItem(item, SelectionType.Exclude, $event)"
            >{{ isItemExcluded(item) ? resolvedLabels.excludedText : resolvedLabels.excludeText }}</a
          >
          <a
            class="link-primary location-item-button-include"
            [class.fw-bold]="isItemIncluded(item)"
            (click)="selectItem(item, SelectionType.Include, $event)"
            >{{ isItemIncluded(item) ? resolvedLabels.includedText : resolvedLabels.includeText }}</a
          >
        </div>
      </f-list-item>
      }

      <!-- No-results row -->
      @if (suggestedItems().length === 0) {
      <f-list-item [withHover]="false" class="px-3 py-2">
        <span class="text-muted body-70">{{ resolvedLabels.noResults }}</span>
      </f-list-item>
      } }

      <!-- ── Hierarchy tree (at rest, no text typed) ────────────────────── -->
      @if (!showSuggest()) { @if (!locationData().length && noDataTemplate) {
      <f-list-item [withHover]="false" class="px-3 py-2">
        <ng-container [ngTemplateOutlet]="noDataTemplate"></ng-container>
      </f-list-item>
      }
      <f-location-hierarchy-item
        [items]="hierarchyItems()"
        [selectedItems]="selectedItems()"
        [excludeText]="resolvedLabels.excludeText"
        [excludedText]="resolvedLabels.excludedText"
        [includeText]="resolvedLabels.includeText"
        [includedText]="resolvedLabels.includedText"
        (itemSelect)="onHierarchySelect($event)"
        (itemToggle)="onHierarchyToggle($event)"
      ></f-location-hierarchy-item>
      }
    </f-list>
  </div>
</div>
